import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-a485bd18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-system-table" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-empty",
  src: _imports_0,
  alt: "img"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-empty" }, "暂无数据", -1))
const _hoisted_5 = {
  key: 0,
  class: "myfooter"
}
const _hoisted_6 = { class: "total" }
const _hoisted_7 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_document = _resolveComponent("document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_edit_pen = _resolveComponent("edit-pen")!
  const _component_delete = _resolveComponent("delete")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_el_table_drag = _resolveDirective("el-table-drag")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, _mergeProps({ ref: "tableBridge" }, _ctx.myTableAttrs, {
        "element-loading-text": "Loading...",
        "element-loading-background": "rgba(0, 0, 0, 0.1)",
        border: "",
        stripe: "",
        "scrollbar-always-on": true,
        data: _ctx.tableData,
        class: ["mytable", {empty:_ctx.tableData.length===0,scrolling:_ctx.scrolling,'not-border-bottom':!_ctx.showBorderBottom}],
        style: [{"width":"100%"}, {'--el-table-inner-wrapper-height':_ctx.elTableInnerWrapperHeight,'--el-table-height':_ctx.elTableHeight}]
      }), {
        empty: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cols, (col, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: col.name || `auto_col_${i}`
            }, [
              (col.type)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    type: col.type,
                    fixed: col.fixed,
                    label: col.zhName,
                    selectable: col.selectable,
                    align: col.align||'center',
                    "header-align": col.headerAlign||'center',
                    width: col.width || 40,
                    "min-width": col.minWidth
                  }, _createSlots({ _: 2 }, [
                    (col.slot)
                      ? {
                          name: "default",
                          fn: _withCtx((props) => [
                            _renderSlot(_ctx.$slots, col.slot, {
                              props: props,
                              col: col
                            }, undefined, true)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["type", "fixed", "label", "selectable", "align", "header-align", "width", "min-width"]))
                : (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    prop: col.name,
                    fixed: col.fixed,
                    label: col.zhName || col.name,
                    "show-overflow-tooltip": col.ellipsis || true,
                    align: col.align,
                    "header-align": col.headerAlign,
                    width: col.width,
                    "min-width": col.minWidth
                  }, {
                    default: _withCtx(({ row, $index }) => [
                      (col.slot)
                        ? _renderSlot(_ctx.$slots, col.slot, {
                            key: 0,
                            row: row,
                            col: col,
                            colName: col.name,
                            $index: $index
                          }, undefined, true)
                        : (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 1,
                            content: 
                  col.formatter
                  ? _ctx.emptyformatter(col.formatter(row[col.name], col, row),col.empty,true)
                  : _ctx.emptyformatter(row[col.name],col.empty,true)
                ,
                            placement: "top-start",
                            "show-after": 1000
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(col.formatter
                ? _ctx.emptyformatter(col.formatter(row[col.name], col, row),col.empty)
                : _ctx.emptyformatter(row[col.name],col.empty)), 1)
                            ]),
                            _: 2
                          }, 1032, ["content"]))
                    ]),
                    _: 2
                  }, 1032, ["prop", "fixed", "label", "show-overflow-tooltip", "align", "header-align", "width", "min-width"]))
            ], 64))
          }), 128)),
          (_ctx.showActionBar)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "操作",
                width: _ctx.myOptions.actionBarWidth,
                align: "left"
              }, {
                default: _withCtx(({ row, $index }) => [
                  _renderSlot(_ctx.$slots, "options", {
                    row: row,
                    $index: $index
                  }, () => [
                    _createVNode(_component_el_space, {
                      size: 12,
                      class: "el-space-vertical-middle"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.myOptions.showDetails !== false)
                          ? _renderSlot(_ctx.$slots, "details", {
                              key: 0,
                              row: row,
                              $index: $index
                            }, () => [
                              _createVNode(_component_el_tooltip, {
                                content: '详情',
                                placement: "top",
                                "show-after": 1000
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_el_link, {
                                    onClick: () => _ctx.onClickDetails(row),
                                    underline: false,
                                    disabled: _ctx.calcShow(row, _ctx.myOptions.details) === 'disable'
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, { class: "bg-box" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_document)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "disabled"]), [
                                    [_vShow, _ctx.calcShow(row, _ctx.myOptions.details) !== 'hidden']
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ], true)
                          : _createCommentVNode("", true),
                        (_ctx.myOptions.showEdit !== false)
                          ? _renderSlot(_ctx.$slots, "edit", {
                              key: 1,
                              row: row,
                              $index: $index
                            }, () => [
                              _createVNode(_component_el_tooltip, {
                                content: '编辑',
                                placement: "top",
                                "show-after": 1000
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_el_link, {
                                    onClick: () => _ctx.onClickEdit(row),
                                    underline: false,
                                    disabled: _ctx.calcShow(row, _ctx.myOptions.edit) === 'disable'
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, { class: "bg-box" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_edit_pen)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "disabled"]), [
                                    [_vShow, _ctx.calcShow(row, _ctx.myOptions.edit) !== 'hidden']
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ], true)
                          : _createCommentVNode("", true),
                        (_ctx.myOptions.showDelete !== false)
                          ? _renderSlot(_ctx.$slots, "delete", {
                              key: 2,
                              row: row,
                              $index: $index
                            }, () => [
                              _createVNode(_component_el_tooltip, {
                                content: '删除',
                                placement: "top",
                                "show-after": 1000
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_el_link, {
                                    class: "no-color",
                                    onClick: () => _ctx.onClickDelete(row),
                                    type: "danger",
                                    underline: false,
                                    disabled: _ctx.calcShow(row, _ctx.myOptions.delete) === 'disable'
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, { class: "bg-box" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_delete)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "disabled"]), [
                                    [_vShow, _ctx.calcShow(row, _ctx.myOptions.delete) !== 'hidden']
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ], true)
                          : _createCommentVNode("", true),
                        _renderSlot(_ctx.$slots, "more", {
                          row: row,
                          $index: $index
                        }, undefined, true)
                      ]),
                      _: 2
                    }, 1024)
                  ], true)
                ]),
                _: 3
              }, 8, ["width"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["data", "class", "style"])), [
        [_directive_el_table_drag, _ctx.dragOptions, _ctx.drag],
        [_directive_loading, _ctx.loading]
      ]),
      (_ctx.showPager)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_pagination, {
              class: "pagination",
              background: "",
              "hide-on-single-page": _ctx.hideSinglePage,
              layout: "prev, pager, next, jumper",
              "current-page": _ctx.mypager.page,
              "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mypager.page) = $event)),
              "page-size": _ctx.mypager.pageSize,
              total: _ctx.mypager.total,
              onCurrentChange: _ctx.reload,
              onPageSize: _ctx.reload
            }, null, 8, ["hide-on-single-page", "current-page", "page-size", "total", "onCurrentChange", "onPageSize"]),
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(" 共 "),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.mypager.total), 1),
              _createTextVNode(" 条 ")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}